import { Hero } from "@/components/Hero";
import { TSM4Suite } from "@/components/TSM4Suite";
import { MitivisePromo } from "@/components/MitivisePromo";
import { Framework } from "@/components/Framework";
import { WhoWeServe } from "@/components/WhoWeServe";
import { Services } from "@/components/Services";
import { Bundles } from "@/components/Bundles";
import { HowItWorks } from "@/components/HowItWorks";
import { Readiness } from "@/components/Readiness";
import { ServiceRequestForm } from "@/components/ServiceRequestForm";
import { Contact } from "@/components/Contact";
import { FAQ } from "@/components/FAQ";
import { FinalCTA } from "@/components/FinalCTA";

export default function Home() {
  return (
    <>
      <Hero />
      <TSM4Suite />
      <MitivisePromo />
      <Framework />
      <WhoWeServe />
      <Services />
      <Bundles />
      <HowItWorks />
      <Readiness />
      <ServiceRequestForm />
      <Contact />
      <FAQ />
      <FinalCTA />
    </>
  );
}
